import StreamingGeoTargeting from "./StreamingGeoTargeting";
export default StreamingGeoTargeting;
